import { ZodType, z } from "zod";

import { FeatureFlagsConfig } from "~/featureFlags";

const ALLIAI_APP = "alliaiapp.com";

const LogoUrlSchema = z
  .preprocess(
    (v) => {
      // null/undefined/non-string -> null
      if (typeof v !== "string") return null;

      const s = v.trim();

      // empty -> null
      return s.length ? s : null;
    },
    z.url({ protocol: /^https?$/ }).nullable(),
  )
  .catch(null);

export const isAlliAiAppHost = (host: string): boolean => {
  const h = host.toLowerCase().trim();

  return h === ALLIAI_APP || h.endsWith(`.${ALLIAI_APP}`);
};

export const FeatureFlagsConfigSchema: ZodType<FeatureFlagsConfig> = z.lazy(
  (): ZodType<FeatureFlagsConfig> =>
    z.record(z.string(), z.union([z.boolean(), FeatureFlagsConfigSchema])),
);

export const WhiteLabelConfigSchema = z
  .object({
    uuid: z.uuid().optional(),
    company_name: z.string(),
    logo_url: LogoUrlSchema,
    host: z.string(),
    features: FeatureFlagsConfigSchema.nullish(),
  })
  .transform((cfg) => ({
    ...cfg,
    alliaiapp: isAlliAiAppHost(cfg.host),
  }));

export type WhiteLabelConfig = z.infer<typeof WhiteLabelConfigSchema>;
